const host = `${__ENV_CONFIG__.MYPARTNER}`;

export const saveTravelGstUrl = `${host}/agents/save-traveller-gst`;
export const deleteTravelGstUrl = `${host}/agents/delete-traveller-gst`;
